import React from 'react';
import {
  FluentProvider,
  createLightTheme,
  createDarkTheme,
  type BrandVariants,
} from '@fluentui/react-components';
import { useAtomValue } from 'jotai';
import { darkModeAtom, isRTLAtom } from '../store';

// FRCS brand — primary teal #1C9B8D, the frcs.org.fj --color-taxation token: the
// Taxation division colour, which is the relevant one for a tax-compliance product.
// Slots 60 and 160 are FRCS's own --faq-primary-dk #147870 and --faq-primary-lt
// #e6f6f5. Body typeface Catamaran (Google Fonts, OFL) as used on frcs.org.fj, with
// Cairo retained as the Arabic fallback since Catamaran has no Arabic coverage.
const brandTheme: BrandVariants = {
  10: '#051413',
  20: '#082622',
  30: '#0b3833',
  40: '#0d4a43',
  50: '#0f5e56',
  60: '#147870',
  70: '#188a7d',
  80: '#1c9b8d',
  90: '#2aa99b',
  100: '#39b9ab',
  110: '#54c0b4',
  120: '#72c3ba',
  130: '#90c8c2',
  140: '#add1cd',
  150: '#cadddb',
  160: '#e6f6f5',
};

const bodyFontStack = '"Catamaran", "Cairo", "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif';
const lightTheme = { ...createLightTheme(brandTheme), fontFamilyBase: bodyFontStack };
const darkTheme = { ...createDarkTheme(brandTheme), fontFamilyBase: bodyFontStack };

export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const darkMode = useAtomValue(darkModeAtom);
  const isRTL = useAtomValue(isRTLAtom);

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <FluentProvider theme={theme} dir={isRTL ? 'rtl' : 'ltr'}>
      {children}
    </FluentProvider>
  );
};
